<mat-sidenav-container>
    <mat-sidenav #sidenav role="navigation">
        <app-sidenav-left (sidenavClose)="sidenav.close()"></app-sidenav-left>
    </mat-sidenav>
    <mat-sidenav-content>
        <app-navbar (sidenavToggle)="sidenav.toggle()"></app-navbar>
        <main>
            <router-outlet></router-outlet>
        </main>
    </mat-sidenav-content>
</mat-sidenav-container>